import React from 'react';
import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const MenuContent = () => (
    <div className="mobile-menu-bottom">
        <ul>
            <li className="bottom-item">
                <AiOutlineMail className="icon" />
                office@reparatiiasfalt.ro
            </li>
            <li className="bottom-item">
                <AiOutlinePhone className="icon" />
                0724.273.258
            </li>
        </ul>
        <div className="bottom-btn">
            <Link to="/contact" className="d-btn theme-btn d-block text-white">
                Contactează-ne
            </Link>
        </div>
    </div>
);

export default MenuContent;
